<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="wcrd_city_escorts_etc"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
    >
      WORK CARDS REQUIRED - DANCERS/ADULT INTERACTIVE CABARET EMPLOYEES/ ESCORT/
      MASSAGE PARLOR/ TOW TRUCK DRIVERS /PAWN OR 2ND HAND EMPLOYEES/ VEHICLE FOR
      HIRE
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <!-- <v-card-title>
            <h4>Visit the following sites to check on warrant status.</h4>
          </v-card-title> -->
          <v-card-title>
            <h4 style="word-break: keep-all; word-wrap: break-word">
              Complete and return the following items.
            </h4>
            <H5>Please call (775) 334-3875 to schedule an appointment.</H5>
          </v-card-title>
          <v-card-text>
            <div class="d-flex flex-column justify-start">
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/WORK_APPLICATION_051820.pdf"
                target="_blank"
                >APPLICATION</a
              >
              <a
                class="mt-3"
                href="https://renopd.com/formAdmin/content/pdfs_lib/FINGERPRINT_BACKGROUND_WAIVER_050620.pdf"
                target="_blank"
                >FINGERPRINT BACKGROUND WAIVER</a
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "wcrd_city_escorts_etc",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
